/** Auto-generated by import-constants plugin. Do not edit manually */

export const optionalImportEntrypoints: string[] = [
  "langchain_community/tools/aws_lambda",
  "langchain_community/tools/aws_sfn",
  "langchain_community/tools/duckduckgo_search",
  "langchain_community/tools/discord",
  "langchain_community/tools/gmail",
  "langchain_community/tools/google_calendar",
  "langchain_community/agents/toolkits/aws_sfn",
  "langchain_community/agents/toolkits/ibm",
  "langchain_community/agents/toolkits/stagehand",
  "langchain_community/embeddings/alibaba_tongyi",
  "langchain_community/embeddings/bedrock",
  "langchain_community/embeddings/cloudflare_workersai",
  "langchain_community/embeddings/cohere",
  "langchain_community/embeddings/bytedance_doubao",
  "langchain_community/embeddings/gradient_ai",
  "langchain_community/embeddings/hf",
  "langchain_community/embeddings/hf_transformers",
  "langchain_community/embeddings/huggingface_transformers",
  "langchain_community/embeddings/ibm",
  "langchain_community/embeddings/jina",
  "langchain_community/embeddings/llama_cpp",
  "langchain_community/embeddings/premai",
  "langchain_community/embeddings/tensorflow",
  "langchain_community/embeddings/tencent_hunyuan",
  "langchain_community/embeddings/tencent_hunyuan/web",
  "langchain_community/embeddings/zhipuai",
  "langchain_community/llms/arcjet",
  "langchain_community/llms/bedrock",
  "langchain_community/llms/bedrock/web",
  "langchain_community/llms/cohere",
  "langchain_community/llms/gradient_ai",
  "langchain_community/llms/hf",
  "langchain_community/llms/ibm",
  "langchain_community/llms/llama_cpp",
  "langchain_community/llms/portkey",
  "langchain_community/llms/raycast",
  "langchain_community/llms/replicate",
  "langchain_community/llms/sagemaker_endpoint",
  "langchain_community/llms/watsonx_ai",
  "langchain_community/llms/writer",
  "langchain_community/llms/layerup_security",
  "langchain_community/vectorstores/analyticdb",
  "langchain_community/vectorstores/astradb",
  "langchain_community/vectorstores/azion_edgesql",
  "langchain_community/vectorstores/azure_aisearch",
  "langchain_community/vectorstores/azure_cosmosdb",
  "langchain_community/vectorstores/cassandra",
  "langchain_community/vectorstores/chroma",
  "langchain_community/vectorstores/clickhouse",
  "langchain_community/vectorstores/closevector/node",
  "langchain_community/vectorstores/closevector/web",
  "langchain_community/vectorstores/cloudflare_vectorize",
  "langchain_community/vectorstores/convex",
  "langchain_community/vectorstores/couchbase_search",
  "langchain_community/vectorstores/couchbase_query",
  "langchain_community/vectorstores/elasticsearch",
  "langchain_community/vectorstores/faiss",
  "langchain_community/vectorstores/googlevertexai",
  "langchain_community/vectorstores/hnswlib",
  "langchain_community/vectorstores/hanavector",
  "langchain_community/vectorstores/lancedb",
  "langchain_community/vectorstores/libsql",
  "langchain_community/vectorstores/mariadb",
  "langchain_community/vectorstores/milvus",
  "langchain_community/vectorstores/momento_vector_index",
  "langchain_community/vectorstores/mongodb_atlas",
  "langchain_community/vectorstores/myscale",
  "langchain_community/vectorstores/neo4j_vector",
  "langchain_community/vectorstores/neon",
  "langchain_community/vectorstores/opensearch",
  "langchain_community/vectorstores/pgvector",
  "langchain_community/vectorstores/pinecone",
  "langchain_community/vectorstores/qdrant",
  "langchain_community/vectorstores/redis",
  "langchain_community/vectorstores/rockset",
  "langchain_community/vectorstores/singlestore",
  "langchain_community/vectorstores/supabase",
  "langchain_community/vectorstores/tigris",
  "langchain_community/vectorstores/typeorm",
  "langchain_community/vectorstores/typesense",
  "langchain_community/vectorstores/upstash",
  "langchain_community/vectorstores/usearch",
  "langchain_community/vectorstores/vercel_postgres",
  "langchain_community/vectorstores/voy",
  "langchain_community/vectorstores/weaviate",
  "langchain_community/vectorstores/xata",
  "langchain_community/vectorstores/zep",
  "langchain_community/vectorstores/zep_cloud",
  "langchain_community/chat_models/arcjet",
  "langchain_community/chat_models/bedrock",
  "langchain_community/chat_models/bedrock/web",
  "langchain_community/chat_models/ibm",
  "langchain_community/chat_models/iflytek_xinghuo",
  "langchain_community/chat_models/iflytek_xinghuo/web",
  "langchain_community/chat_models/llama_cpp",
  "langchain_community/chat_models/portkey",
  "langchain_community/chat_models/premai",
  "langchain_community/chat_models/tencent_hunyuan",
  "langchain_community/chat_models/tencent_hunyuan/web",
  "langchain_community/chat_models/webllm",
  "langchain_community/chat_models/zhipuai",
  "langchain_community/callbacks/handlers/llmonitor",
  "langchain_community/callbacks/handlers/lunary",
  "langchain_community/callbacks/handlers/upstash_ratelimit",
  "langchain_community/retrievers/amazon_kendra",
  "langchain_community/retrievers/amazon_knowledge_base",
  "langchain_community/retrievers/arxiv",
  "langchain_community/retrievers/azion_edgesql",
  "langchain_community/retrievers/metal",
  "langchain_community/retrievers/supabase",
  "langchain_community/retrievers/vectara_summary",
  "langchain_community/retrievers/zep",
  "langchain_community/structured_query/chroma",
  "langchain_community/structured_query/qdrant",
  "langchain_community/structured_query/supabase",
  "langchain_community/structured_query/vectara",
  "langchain_community/retrievers/zep_cloud",
  "langchain_community/graphs/memgraph_graph",
  "langchain_community/graphs/neo4j_graph",
  "langchain_community/document_compressors/ibm",
  "langchain_community/document_transformers/html_to_text",
  "langchain_community/document_transformers/mozilla_readability",
  "langchain_community/storage/cassandra",
  "langchain_community/storage/convex",
  "langchain_community/storage/ioredis",
  "langchain_community/storage/upstash_redis",
  "langchain_community/storage/vercel_kv",
  "langchain_community/stores/message/astradb",
  "langchain_community/stores/message/cassandra",
  "langchain_community/stores/message/cloudflare_d1",
  "langchain_community/stores/message/convex",
  "langchain_community/stores/message/dynamodb",
  "langchain_community/stores/message/firestore",
  "langchain_community/stores/message/ipfs_datastore",
  "langchain_community/stores/message/ioredis",
  "langchain_community/stores/message/momento",
  "langchain_community/stores/message/mongodb",
  "langchain_community/stores/message/neo4j",
  "langchain_community/stores/message/planetscale",
  "langchain_community/stores/message/postgres",
  "langchain_community/stores/message/aurora_dsql",
  "langchain_community/stores/message/redis",
  "langchain_community/stores/message/upstash_redis",
  "langchain_community/stores/message/xata",
  "langchain_community/stores/message/zep_cloud",
  "langchain_community/memory/mem0",
  "langchain_community/memory/motorhead_memory",
  "langchain_community/memory/zep",
  "langchain_community/memory/zep_cloud",
  "langchain_community/indexes/postgres",
  "langchain_community/indexes/sqlite",
  "langchain_community/document_loaders/web/apify_dataset",
  "langchain_community/document_loaders/web/assemblyai",
  "langchain_community/document_loaders/web/azure_blob_storage_container",
  "langchain_community/document_loaders/web/azure_blob_storage_file",
  "langchain_community/document_loaders/web/browserbase",
  "langchain_community/document_loaders/web/cheerio",
  "langchain_community/document_loaders/web/puppeteer",
  "langchain_community/document_loaders/web/playwright",
  "langchain_community/document_loaders/web/college_confidential",
  "langchain_community/document_loaders/web/gitbook",
  "langchain_community/document_loaders/web/hn",
  "langchain_community/document_loaders/web/imsdb",
  "langchain_community/document_loaders/web/figma",
  "langchain_community/document_loaders/web/firecrawl",
  "langchain_community/document_loaders/web/github",
  "langchain_community/document_loaders/web/taskade",
  "langchain_community/document_loaders/web/notionapi",
  "langchain_community/document_loaders/web/pdf",
  "langchain_community/document_loaders/web/recursive_url",
  "langchain_community/document_loaders/web/s3",
  "langchain_community/document_loaders/web/sitemap",
  "langchain_community/document_loaders/web/sonix_audio",
  "langchain_community/document_loaders/web/confluence",
  "langchain_community/document_loaders/web/couchbase",
  "langchain_community/document_loaders/web/spider",
  "langchain_community/document_loaders/web/youtube",
  "langchain_community/document_loaders/fs/chatgpt",
  "langchain_community/document_loaders/fs/srt",
  "langchain_community/document_loaders/fs/pdf",
  "langchain_community/document_loaders/fs/docx",
  "langchain_community/document_loaders/fs/epub",
  "langchain_community/document_loaders/fs/csv",
  "langchain_community/document_loaders/fs/notion",
  "langchain_community/document_loaders/fs/obsidian",
  "langchain_community/document_loaders/fs/unstructured",
  "langchain_community/document_loaders/fs/openai_whisper_audio",
  "langchain_community/document_loaders/fs/pptx",
  "langchain_community/utils/convex",
  "langchain_community/utils/cassandra",
  "langchain_community/experimental/multimodal_embeddings/googlevertexai",
  "langchain_community/experimental/hubs/makersuite/googlemakersuitehub",
  "langchain_community/experimental/tools/pyinterpreter",
  "langchain_community/chains/graph_qa/cypher",
];
